import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Q16 = ({ userId, onNext, onPrevious, saveResponse }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    const options = [
        { value: 1, label: t('questions.q16.options.option1') },
        { value: 2, label: t('questions.q16.options.option2') },
        { value: 3, label: t('questions.q16.options.option3') },
        { value: 4, label: t('questions.q16.options.option4') }
    ];

    useEffect(() => {
        const fetchExistingResponse = async () => {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (!user || !user.token) {
                    throw new Error('No token found in localStorage');
                }
                const token = user.token;

                const baseUrl = process.env.REACT_APP_API_URL;

                const response = await axios.get(`${baseUrl}/survey/get-response/q16/${userId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (response.data && response.data.score) {
                    setSelectedOption(response.data);
                }
            } catch (error) {
                console.error('Error fetching existing response:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchExistingResponse();
    }, [userId]);

    const handleOptionChange = (e) => {
        const selectedValue = parseInt(e.target.value);
        const selectedLabel = options.find(option => option.value === selectedValue).label;
        setSelectedOption({ score: selectedValue, description: selectedLabel });
    };

    const handleNext = () => {
        saveResponse('q16', selectedOption);
        onNext();
    };

    if (loading) {
        return <p>{t('questions.q16.loading')}</p>;
    }

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h3>{t('questions.q16.title')}</h3>
            <form>
                {options.map(option => (
                    <div key={option.value}>
                        <input
                            type="radio"
                            id={`option${option.value}`}
                            name="q16"
                            value={option.value}
                            checked={selectedOption && selectedOption.score === option.value}
                            onChange={handleOptionChange}
                        />
                        <label htmlFor={`option${option.value}`}>{option.label} ({option.value})</label>
                    </div>
                ))}
            </form>
            <button onClick={onPrevious} style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px' }}>{t('questions.q16.previous')}</button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button onClick={handleNext} style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px' }} disabled={!selectedOption}>{t('questions.q16.next')}</button>
        </div>
    );
};

export default Q16;
